/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ImportStatus = {
    Pending: 'Pending',
    Uploading: 'Uploading',
    Uploaded: 'Uploaded',
    Merging: 'Merging',
    Merged: 'Merged',
    Mapping: 'Mapping',
    Mapped: 'Mapped',
    Validating: 'Validating',
    Validated: 'Validated',
    ValidatedWithWarnings: 'ValidatedWithWarnings',
    ValidatedWithErrors: 'ValidatedWithErrors',
    Staging: 'Staging',
    Staged: 'Staged',
    Committing: 'Committing',
    Committed: 'Committed',
    CommittedWithErrors: 'CommittedWithErrors',
    Geocoding: 'Geocoding',
    Geocoded: 'Geocoded',
    OsmProcessing: 'OsmProcessing',
    OsmProcessed: 'OsmProcessed',
    Failed: 'Failed',
    Cancelled: 'Cancelled'
} as const;
export type ImportStatus = typeof ImportStatus[keyof typeof ImportStatus];


export function instanceOfImportStatus(value: any): boolean {
    for (const key in ImportStatus) {
        if (Object.prototype.hasOwnProperty.call(ImportStatus, key)) {
            if (ImportStatus[key as keyof typeof ImportStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ImportStatusFromJSON(json: any): ImportStatus {
    return ImportStatusFromJSONTyped(json, false);
}

export function ImportStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportStatus {
    return json as ImportStatus;
}

export function ImportStatusToJSON(value?: ImportStatus | null): any {
    return value as any;
}

export function ImportStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ImportStatus {
    return value as ImportStatus;
}

